export function isValidTicketColor(colorValue) {
  if (!colorValue || typeof colorValue !== "string") {
    return false;
  }
  const hexColorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
  return hexColorRegex.test(colorValue);
}
